module.exports = __webpack_public_path__ + "static/media/Spinner-1s-200px.03ee1514.svg";